import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { VINReelsKeys } from './VINReelsKeys';
import { VINReel, VINReelSortKey } from './types';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { useToastError } from 'lib/hooks';

export type GetVINReelsParams = {
  start?: number;
  limit?: number;
  search?: string;
  order?: PaginationConstants;
  sortKey?: VINReelSortKey;
};

interface IGetVINReelsResult {
  count: number;
  data: VINReel[];
}

const getVINReels = async (params: GetVINReelsParams) => {
  return (
    await EXPRESS_API.get('/vinreels', {
      params,
    })
  ).data as Promise<IGetVINReelsResult>;
};

export const useGetVINReelsQuery = (params: GetVINReelsParams) => {
  const { showError } = useToastError();
  return useQuery(VINReelsKeys.list(params), () => getVINReels(params), {
    onError: err => {
      showError(err);
    },
  });
};
